/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

export const POSTER_IMAGE_WIDTH = 662;

export const POSTER_IMAGE_HEIGHT = 372;

export const OLG_EPISODIC_POSTER_IMAGE_WIDTH = 372;

export const OLG_EPISODIC_POSTER_IMAGE_HEIGHT = 279;

export const OLG_MOVIE_POSTER_IMAGE_WIDTH = 186;

export const OLG_MOVIE_POSTER_IMAGE_HEIGHT = 279;

export const MOVIE_POSTER_PREFIX = 'moviePoster_';

/* Poster Image Name can be anyof the following: atmospheric_, showcaseBanner_ */
export const POSTER_IMAGE_NAME = 'showcaseBanner_';

export const PROVIDER_IMAGE_WIDTH = 49;

export const PROVIDER_IMAGE_HEIGHT = 49;

export const PROVIDER_IMAGE_NAME = 'partnerSourceLogo_';

export const RECORDING_PREVIEW_IMAGE_NAME = 'episodeBanner_';

export const RECORDING_PREVIEW_WIDTH = 444;

export const RECORDING_PREVIEW_MOVIE_WIDTH = 166;

export const RECORDING_PREVIEW_HEIGHT = 250;
